import React, { Component } from 'react';
import Link from 'gatsby-link';
import styles from './styles.module.css';

import PillButton from '../pill-button';

export default class ContributeBanner extends Component {
  state = {
    open: false,
  };

  componentDidMount() {
    if (typeof localStorage !== 'undefined') {
      const dismissed = localStorage.getItem('contribute-banner-dismissed');
      if (!dismissed) {
        this.setState({ open: true });
      }
    }
  }

  dismissBanner = () => {
    this.setState({ open: false });
    localStorage.setItem('contribute-banner-dismissed', 'true');
  };

  render() {
    return (
      this.state.open && (
        <div className={styles.container}>
          <div className={styles.inner}>
            <div>
              <strong>Contribute your knowledge</strong>
            </div>
            <p
              style={{
                fontSize: '14px',
                margin: '0.5rem 0',
              }}
            >
              Are you passionate about Whitefriars glass, know a Whitefriars
              stained glass window near you or remember the factory? We need to
              your knowledge. All of our information is contributed by people
              just like you. Get started today, it only takes a few minutes.
            </p>
            <div className={styles.buttons}>
              <PillButton
                small
                text="Get started"
                tag={Link}
                to="/contribute"
              />
              <PillButton
                small
                theme="black-ghost"
                text="Close"
                onClick={this.dismissBanner}
              />
            </div>
          </div>
        </div>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contribute-banner/index.js